const vars = {
  alarmsPageSidePanelWidth: 300,
  alarmsPageTopPanelHeight: 50,
  alarmStatusPadding: 14,
  alarmVerificationQuestionnaireHeight: 120,
  cameraItemHeight: 180,
  cameraItemMargin: 20,
  cameraItemWidth: 320,
  cameraItemLocationCardHeight: 225,
  cameraItemAllLocationsCardHeight: 264,
  cameraItemFloorplanHeight: 146,
  cameraItemFloorplanWidth: 166,
  cameraItemCameraGroupCardHeight: 274,
  cameraSelectorMiniHeight: 180,
  cameraSelectorMiniHeightMedium: 156,
  cameraSelectorMiniHeightSmall: 132,
  cameraSelectorMiniMouseDetectionAreaHeight: 20,
  cameraSelectorMiniScrollerPaddingTop: 5,
  cameraSelectorPlayList: 160,
  cameraSelectorSearchHeight: 65,
  camerasPageSecondTitlePanelHeight: 50,
  camerasPageSidePanelBorder: 2,
  camerasPageSidePanelCollapsedWidthFloorplan: 25,
  camerasPageSidePanelWidth: 345,
  cameraPageSidePanelScrollBarWidth: 8,
  camerasPageTopPanelHeight: 50,
  clusterMarkerSize: 40,
  desktopNavWidth: 80,
  desktopNavWidthTransform: -70,
  desktopTopNavHeight: 48,
  desktopTopNavHeightTransform: -48,
  drawerCollapsedWidth: 25,
  drawerExpandedWidth: 300,
  drawerForcedOpenOnWidth: 2000,
  eventCardWidthMargin: 10,
  eventDetailListNavButtonHeight: 50,
  eventFilterElementHeight: 36,
  eventFilterHeight: 90,
  eventGridItemImgHeight: 180,
  eventGridItemWidth: 320,
  eventListPanelWidth: 380,
  eventPageLeftMargin: 450,
  eventPageReportPanelWidth: 300,
  eventPlayerControlHeight: 40,
  fieldLabelMarginBottom: 6,
  fieldLabelFontSize: 13,
  globalDatePickerWidth: 250,
  histogramContainerHeight: 182,
  locationSelectorBodyPadding: 12,
  locationSelectorFiltersWidth: 360,
  locationSelectorLocationHeight: 50,
  locationSelectorLocationsWidth: 360,
  markerOverlayBorder: 0,
  miniCameraItemHeight: 154,
  miniCameraItemHeightMedium: 136,
  miniCameraItemHeightSmall: 112,
  miniCameraItemLabelHeight: 33,
  miniCameraItemMarginRight: 5,
  miniCameraItemThumbnailHeight: 132,
  miniCameraItemThumbnailWidth: 235,
  miniCameraItemWidth: 249,
  miniCameraItemWidthMedium: 170,
  miniCameraItemWidthSmall: 130,
  miniCameraListSourceIcon: 22,
  miniCameraListSourceIconSmall: 20,
  miniCameraPanel: 300,
  miniCameraSelectorHeight: 180,
  minorOutageBannerHeight: 50,
  previewImageHeight: 230,
  previewImageWidth: 300,
  sliderMinimizedWidth: 25,
  videoMainChartHeight: 135,
  videoMiniMapHeight: 55,
  videoPlayerOptionsHeight: 48,
  videoPlayerOptionsIconSize: 22,
  videoControlHeight: 190,
  videoTimePickerWidth: 892,
  videoPeopleCountingDrawerHeaderHeight: 42,
  widgetCardPadding: 16,
  widgetCardWidth: 360,
  widgetFooterHeight: 60,
  widgetLongRankingDrilldownHeight: 620,
  widgetLongRankingPreviewHeight: 580,
  widgetPreviewHeight: 320,
  widgetSettingsFieldWidth: 400,
  widgetSettingsPadding: 18,
  locationDetailsTooltipArrowWidth: 10,
  locationDetailsTooltipOffsetY: 35,
  videoSearchItemFooterHeight: 85,
  aiVideoConfigHeaderHeight: 90,
};

// Set CSS variables for all variables.
try {
  if (typeof document !== 'undefined') {
    for (const [variable, value] of Object.entries(vars)) {
      document.documentElement.style.setProperty(`--${variable}`, value === 0 ? '0' : `${value}px`);
    }
  }
} catch (err) {
  console.error(err);
}

export default vars;
